<template>
  <div class="sidebar-products-wrap">
    <div
      v-if="!conversationUiFlags.isFetching"
      class="contact-conversation--list"
    >
      <div
        v-on-clickaway="closeDropdownProductLabel"
        class="product-wrap"
        @keyup.esc="closeDropdownProductLabel"
      >
        <add-product-label @add="toggleProductLabels" />
        <woot-label
          v-for="productLabel in activeProductLabels"
          :key="productLabel.id"
          :title="productLabel.title"
          :description="productLabel.description"
          :show-close="true"
          :color="productLabel.color"
          variant="smooth"
          @click="removeProductLabelFromConversation"
        />

        <div class="dropdown-wrap">
          <div
            :class="{ 'dropdown-pane--open': showSearchDropdownProductLabel }"
            class="dropdown-pane"
          >
            <product-label-dropdown
              v-if="showSearchDropdownProductLabel"
              :account-product-labels="accountProductLabels"
              :selected-product-labels="savedProductLabels"
              @add="addProductLabelToConversation"
              @remove="removeProductLabelFromConversation"
            />
          </div>
        </div>
      </div>
    </div>
    <spinner v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner';
import ProductLabelDropdown from 'shared/components/ui/productLabel/ProductLabelDropdown';
import AddProductLabel from 'shared/components/ui/dropdown/AddProductLabel';
import { mixin as clickaway } from 'vue-clickaway';
import conversationProductLabelMixin from 'dashboard/mixins/conversation/productLabelMixin';

export default {
  components: {
    Spinner,
    ProductLabelDropdown,
    AddProductLabel,
  },

  mixins: [clickaway, conversationProductLabelMixin],
  props: {
    conversationId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      selectedProductLabels: [],
      showSearchDropdownProductLabel: false,
    };
  },

  computed: {
    ...mapGetters({
      conversationUiFlags: 'conversationProductLabels/getUIFlags',
      productUiFlags: 'conversationProductLabels/getUIFlags',
    }),
  },
  methods: {
    toggleProductLabels() {
      this.showSearchDropdownProductLabel =
        !this.showSearchDropdownProductLabel;
    },
    closeDropdownProductLabel() {
      this.showSearchDropdownProductLabel = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-products-wrap {
  margin-bottom: 0;
}
.contact-conversation--list {
  width: 100%;

  .product-wrap {
    line-height: var(--space-medium);
    position: relative;

    .dropdown-wrap {
      display: flex;
      left: -1px;
      margin-right: var(--space-medium);
      position: absolute;
      top: var(--space-medium);
      width: 100%;

      .dropdown-pane {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}

.error {
  color: var(--r-500);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);
}
</style>

